import { useLang } from '../context/LangContext';
import '../css/footer.css';

const NAV = [
  { href: '#home',      en: 'Home',      ar: 'الرئيسية' },
  { href: '#about',     en: 'About',     ar: 'عنّا' },
  { href: '#services',  en: 'Services',  ar: 'خدماتنا' },
  { href: '#portfolio', en: 'Portfolio', ar: 'أعمالنا' },
  { href: '#contact',   en: 'Contact',   ar: 'تواصل' },
];

export default function Footer() {
  const { lang } = useLang();
  const scrollTo = href => document.getElementById(href.replace('#',''))?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Brand */}
        <div className="footer-brand">
          <img src="/logo.png" alt="AMKO" className="footer-logo" />
          <span>AMKO<span className="footer-accent">IQ</span></span>
        </div>

        {/* Nav */}
        <nav className="footer-nav">
          {NAV.map(n => (
            <button key={n.href} onClick={() => scrollTo(n.href)}>
              {lang === 'ar' ? n.ar : n.en}
            </button>
          ))}
        </nav>

        {/* Copy */}
        <p className="footer-copy">
          © {new Date().getFullYear()} AMKO Agency
        </p>
      </div>
    </footer>
  );
}
